module.exports = __webpack_public_path__ + "static/media/location.a4328505.svg";